var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayWhiteNavyBlueBgRoundedNavyBorder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 13.5,
    fill: "#454A67",
    stroke: "#333541"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4709 8.08477C11.7603 7.95562 12.1095 7.97521 12.3768 8.13558L21.1268 13.3856C21.3607 13.5259 21.5 13.7553 21.5 14C21.5 14.2447 21.3607 14.4741 21.1268 14.6144L12.3768 19.8644C12.1095 20.0248 11.7603 20.0444 11.4709 19.9152C11.1815 19.7861 11 19.5297 11 19.25V8.75C11 8.47035 11.1815 8.21392 11.4709 8.08477Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayWhiteNavyBlueBgRoundedNavyBorder);
export default __webpack_public_path__ + "static/media/playWhiteNavyBlueBgRoundedNavyBorder.f62e5d0cb3fd91848c6f1ec449383f98.svg";
export { ForwardRef as ReactComponent };